import ModelType from '../../Model/ModelType';
import { Aggregation, TimeBucket } from '../../../services/constants';
import T from '../../../localization/LocalizationKeys';
import { AggregateModel, IntervalModel } from '../../Model/Models';
import SignalFunction from './util/SignalFunction';
import _ from 'lodash';
import NodeDataSource from './NodeDataSource';

const LastValueDataSource =
  ({
    nodes,
    signals = [],
    aggregate = Aggregation.MEAN,
    interval = TimeBucket.PT1H,
    timeRange,
    reloadTrigger,
    dashboardDate
  }) => {
    const {
      hasError,
      isLoading,
      timespan,
      data,
      signalData } = SignalFunction({
      nodes,
      signals,
      timeRange,
      aggregate,
      interval,
      reloadTrigger,
      dashboardDate
    });
    const lastSignalData = _.map(signalData, (signal) => {
      return {
        ...signal,
        dataPoints: [_.last(signal.dataPoints)]
      };
    });

    return { hasError, isLoading, timespan, interval, data, signalData: lastSignalData };
  };

LastValueDataSource.models = [
  ...NodeDataSource.models,
  {
    path: 'signals',
    type: ModelType.SIGNALS,
    label: T.common.signals
  },
  AggregateModel,
  IntervalModel,
  {
    path: 'timeRange',
    type: ModelType.TIME_RANGE,
    label: T.common.input.timerange.title
  }

];

LastValueDataSource.getUsedAssets = (data) => {
  return NodeDataSource.getUsedAssets(data);
};

export default LastValueDataSource;
